import React from 'react'
import { Button } from '@frontend/ui-kit/agromarket/components/Button'
import { GlassMorphIcon } from '@/components/ui'
import type { TenderWarningModalProps } from '@/pages/Profiles/UserProfile/components/Tender/modals/TenderWarningModal/types'
import './styles.scss'

const TenderWarningModal = (props: TenderWarningModalProps) => {
  const { options } = props
  const { title, messages, buttonTitle, onButtonClick } = options

  return (
    <section className="tenderWarningModal">
      <GlassMorphIcon image="attention-red" />

      <h3 className="tenderWarningModal__title">{title}</h3>
      {messages.map((message, index) => (
        <p className="tenderWarningModal__message" key={index}>
          {message}
        </p>
      ))}

      <div className="tenderWarningModal__buttons">
        <Button variant="primary" size="lg" onClick={onButtonClick}>
          {buttonTitle}
        </Button>
      </div>
    </section>
  )
}

export default TenderWarningModal
